import {useRef, useState} from "react";
import styled, {ThemeProvider} from "styled-components";
import {useAppDispatch} from "../../app/hooks";

import {deliveryApi} from "../../api/delivery-api";
import {scheduleApi} from "../../api/schedule-api";
import {setSchedulePageByDtoAction} from "../../app/reducers/schedule-slice";
import theme from "../../style/theme";
import {DeliveryGroup} from "../../types/schedule/delivery-group";
import {Schedule} from "../../types/schedule/schedule";
import ButtonBase from "../button/ButtonBase";
import {ActionGroup} from "../dialog/DeliveryGroupDialogContent";
import {LineNameCardPhoneDialog} from "../dialog/LineNameCardPhoneDialog";
import Icon from "../icon/Icon";
import ArrowDropDownFillIcon from "../icons/ArrowDropDownFillIcon/ArrowDropDownFillIcon";
import ArrowDropUpFillIcon from "../icons/ArrowDropUpFillIcon/ArrowDropUpFillIcon";
import {InspectorToggleItem} from "./InspectorToggleItem";
import DeliveryIssueDialog from "../dialog/DeliveryIssueDialog";

interface Props {
    key?: string;
    actionGroup: ActionGroup;
    schedule: Schedule;
    deliveryGroup: DeliveryGroup;
}

export const DeliveryGroupInspectorItem: React.FC<Props> = (
    {
        actionGroup,
        schedule,
        deliveryGroup,
    }
) => {
    const dispatch = useAppDispatch();
    const [commentInToggle, setCommentInToggle] = useState("");
    const [open, setOpen] = useState(false);
    const textAreaRef = useRef<HTMLTextAreaElement>(null);
    const [active, setActive] = useState(false);
    const [issueDialogDeliveryId, setIssueDialogDeliveryId] = useState<string | null>(null);

    const handleChangeCommentInToggle = (e: any) => {
        setCommentInToggle(e.target.value);
    };

    const submitComment = async () => {
        try {
            await deliveryApi.commentDeliveries({
                deliveryIds: deliveryGroup.deliveryIds,
                comment: commentInToggle,
            });
        } catch (error) {
            console.log(error);
        }

        try {
            const response = await scheduleApi.getById(schedule.id);
            dispatch(setSchedulePageByDtoAction({scheduleDto: response.data}));
        } catch (error) {
            console.log(error);
        }
    };

    const handleClickCustomButton = () => {
        if (!active) {
            submitComment();
        }
        setActive(!active);
    };

    const handleClickToggleBoxOpen = () => {
        setOpen(!open);
    };

    // const handleClickIssueCheckBox = async () => {
    //   if (delivery.pickUpAction.issueStatus === IssueStatus.Occur) {
    //     refreshScheduleHelperAsync(
    //       deliveryApi.solvePickUpIssue(delivery.id),
    //       schedule.id
    //     );
    //   } else {
    //     refreshScheduleHelperAsync(
    //       deliveryApi.occurPickUpIssue(delivery.id),
    //       schedule.id
    //     );
    //   }
    // };

    // const handleChangeCommentInToggle = (e: any) => {
    //   setCommentInToggle(e.target.value);
    // };

    // const handleClickSubmitButtonInToggle = async () => {
    //   refreshScheduleHelperAsync(
    //     deliveryApi.commentDelivery({
    //       deliveryId: delivery.id,
    //       comment: commentInToggle,
    //     }),
    //     schedule.id
    //   );
    // };

    return (
        <ThemeProvider theme={theme}>
            <ToggleBox>
                <div
                    style={{
                        // display: "flex",
                        position: "relative",
                        width: "388px",
                    }}
                >
                    <ClickBox onClick={handleClickToggleBoxOpen}>
                        <CustomIcon color={`${true ? "black" : "gray400"}`}>
                            {open ? <ArrowDropUpFillIcon/> : <ArrowDropDownFillIcon/>}
                        </CustomIcon>

                        <CustomP>{actionGroup.actionKey}</CustomP>
                        <LineNameCardContainer>
                            <LineNameCardPhoneDialog
                                phone={
                                    actionGroup.deliveries[0].inProgressWorkPlace.phone
                                        ? actionGroup.deliveries[0].inProgressWorkPlace.phone
                                        : ""
                                }
                            />
                        </LineNameCardContainer>
                    </ClickBox>

                    {open &&
                        actionGroup.deliveries.map((delivery) => {
                            return (
                                <InspectorToggleItem schedule={schedule} delivery={delivery}/>
                            );
                        })}
                </div>
                {open && (
                    <CommentContainer>
                        <CommentHeader>관리자 메모</CommentHeader>
                        <TextAreaBox>
                            <CustomTextArea
                                ref={textAreaRef}
                                onChange={handleChangeCommentInToggle}
                                placeholder="코멘트를 작성하세요."
                                defaultValue={actionGroup.deliveries[0].comment}
                                disabled={active}
                            ></CustomTextArea>
                        </TextAreaBox>

                        <ButtonRow>
                            <IssueRegisterButton
                                onClick={() =>
                                    setIssueDialogDeliveryId(actionGroup.deliveries[0].id)
                                }
                            >
                                이슈 등록
                            </IssueRegisterButton>
                            <CustomButton onClick={handleClickCustomButton}>
                                {active ? "입력하기" : "입력완료"}
                            </CustomButton>
                        </ButtonRow>
                    </CommentContainer>
                )}
                <DeliveryIssueDialog
                    deliveryId={issueDialogDeliveryId}
                    open={!!issueDialogDeliveryId}
                    onClose={() => setIssueDialogDeliveryId(null)}
                />
            </ToggleBox>
        </ThemeProvider>
        // <Toggle
        //   key={delivery.id}
        //   onClickChecked={handleClickIssueCheckBox}
        //   onClick={handleClickSubmitButtonInToggle}
        //   onChange={handleChangeCommentInToggle}
        //   borderBottom
        //   phoneNumber={delivery.pickUpAction.workPlace.phone || ""}
        //   requestText={delivery.pickUpAction.requirement}
        //   commentText={delivery.comment || ""}
        //   checked={delivery.pickUpAction.issueStatus === IssueStatus.Occur}
        // >
        //   {loadFormat}
        // </Toggle>
    );
};

const ToggleBox = styled.div`
  width: 388px;
  margin: 0 auto;
  padding-bottom: 12px;

  & > div:nth-last-child(2) > div:last-child > div {
    border-bottom: none;
  }
`;

const ClickBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  min-height: 33px;
  cursor: pointer;
`;

const CustomIcon = styled(Icon)`
  position: absolute;
  top: 8px;
  left: 0;
  width: 24px;
  height: 24px;
  padding: 10px 8px;
  margin-right: 2px;
`;

const CustomP = styled.p`
  padding: 12px 0px 0px 26px;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 21px;
  font-weight: 500;
  color: #000000;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

const TextAreaBox = styled.div`
  width: 100%;
  height: 99px;
  background-color: white;
  border: 1px solid ${(props: any) => props.theme.palette.primitives.gray200};
`;

const CustomTextArea = styled.textarea`
  width: 100%;
  height: 100%;
  padding: 12px;
  font-weight: 400;
  font-size: 13px;
  line-height: 19px;
  color: ${(props: any) => props.theme.palette.primitives.gray600};
  background: transparent;
  border: 1px solid transparent;
  overflow: auto;
  vertical-align: top;
  resize: none;
  box-sizing: border-box;

  &:focus {
    outline: 0;
  }
`;

const CustomButton = styled(ButtonBase)`
  display: block;
  width: 66px;
  height: 23px;
  border-radius: 2px;
  margin-left: auto;
  margin-top: 9px;
  background: #ebeef3;
  color: ${(props: any) => props.theme.palette.primitives.gray600};
`;

const CommentContainer = styled.div`
  padding: 12px 0 0 26px;
`;

const CommentHeader = styled.div`
  color: #2a2f36;
  font-weight: 500;
  height: 14px;
  font-size: 12px;
  margin-bottom: 8px;
`;

const LineNameCardContainer = styled.div`
  margin-left: 5px;
  margin-top: 11px;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin-top: 9px;
`;

const IssueRegisterButton = styled.button`
  display: block;
  height: 23px;
  padding: 0 12px;
  border-radius: 2px;
  border: 1px solid ${theme.palette.primitives.red200};
  background: ${theme.palette.primitives.red50};
  color: ${theme.palette.foundation.negative};
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  &:hover { background: ${theme.palette.primitives.red100}; }
`;
